import { Element, Svg } from '@svgdotjs/svg.js';
import { ww } from 'bobjoll/ts/library/dom';
import { EditorHelpers } from 'Pods/editor/editor.helpers';
import { ColorUicon } from 'Pods/editor/colorUicon';
import { HistoryEvent } from 'Pods/editor/history';

import { Editor } from '../editor';
import { formatColor } from './formatColor';
import { getFillFromElement } from './getFillFromElement';
import { getStrokeFromElement } from './getStrokeFromElement';

const historyColorLimit = 6;
let gradientColorsHexArray: any = [];
const lengthExagesimalColorWithAlpha = 9;

const checkGradient = function(svg: HTMLElement) {
    if (svg.querySelectorAll('linearGradient').length > 0) {
        document.querySelector('.only_registered .alert_no_user')?.classList.add('hidden');
        document.querySelector('.only_registered .alert_icon_gradient')?.classList.remove('hidden');
        document.querySelector('.only_registered')?.classList.remove('hidden');
        return true;
    } else {
        document.querySelector('.only_registered .alert_icon_gradient')?.classList.add('hidden');
    }
    return false;
};

const getFillColorFromClosestParentWithFillColor = (element: Element): string | null | undefined => {
    const node = element.node;
    const parentWithFillAttribute = node.parents('g[fill]').shift();

    return parentWithFillAttribute?.getAttribute('fill');
};

let idsForChangeToXlinkHref: Record<string, string> = {};

const getColors = function(svg: Svg, resourceType?: string) {
    let svgElements = svg.find('path, circle, ellipse, polygon, line, rect, polyline');
    let svgGradientElements = svg.find('linearGradient, radialGradient');
    let colors: string[] = [];
    let gradients: string[] = [];
    let gradientsElementsIdArray: string[] = [];
    if (svgGradientElements.length > 0) {
        svgGradientElements.forEach((element, index) => {
            let gradientElementChildrens = element.node.children;
            let rgbGradientColorsArray: any[] = [];
            let gradientOffSetArray: any = [];
            if (element.attr('id') && !element.attr('xlink:href')) {
                gradientsElementsIdArray.push(element.attr('id'));
            }

            if (gradientElementChildrens.length > 0) {
                Array.from(gradientElementChildrens).forEach(children => {
                    if (children.getAttribute('stop-color') || children.getAttribute('style')) {
                        let gradientColor = children.getAttribute('style')
                            ? formatColor(children.getAttribute('style')?.replace('stop-color:', ''))
                            : formatColor(children.getAttribute('stop-color'));
                        if (children.getAttribute('style')) {
                            gradientColor = formatColor(children.getAttribute('style')?.replace('stop-color:', ''));
                            children.setAttribute('stop-color', gradientColor);
                        } else {
                            gradientColor = formatColor(children.getAttribute('stop-color'));
                        }

                        let rgbGradientColor = hexToRgb(gradientColor);
                        let gradientOffSet: any = children.getAttribute('offset');
                        gradientColorsHexArray.push(gradientColor);
                        rgbGradientColorsArray.push(`rgb(${rgbGradientColor})`);
                        gradientOffSetArray.push(parseFloat(gradientOffSet));
                    }
                });

                if (index === 0) {
                    Editor.gradientColorsArray = [rgbGradientColorsArray, gradientOffSetArray].reduce((c, v) => {
                        v.forEach((o: number, i: number) => {
                            c[i] = c[i] || [];
                            c[i].push(o);
                        });
                        return c;
                    }, []);
                }

                gradients.push(
                    `linear-gradient(90deg, ${rgbGradientColorsArray[0]} 0%, ${
                        rgbGradientColorsArray[rgbGradientColorsArray.length - 2]
                    } 35%, ${rgbGradientColorsArray[rgbGradientColorsArray.length - 1]} 100%);`,
                );
            } else {
                const xlinkHrefToChange = element.node.getAttribute('xlink:href')?.slice(1);
                const idToChange = element.node.getAttribute('id');

                if (xlinkHrefToChange && idToChange) {
                    idsForChangeToXlinkHref[idToChange] = xlinkHrefToChange;
                }
            }
        });
    }

    if (svgElements) {
        svgElements.forEach(element => {
            let color = '#000000';

            let style = element.attr('style');

            if (svgGradientElements.length > 0) {
                element.click(function() {
                    let regex = new RegExp('#(?<id>[\\w-]+)', 'gi');
                    //@ts-ignore
                    let buttonId = this.attr('data-original');
                    let cleanButtonId = regex.exec(buttonId)?.groups?.id;
                    if (cleanButtonId) {
                        (document.querySelector(
                            `.icon-colors button[data-original="${cleanButtonId}"]`,
                        ) as HTMLButtonElement)?.click();
                    }
                });
            }

            if (style && style.indexOf('fill:') != -1) {
                let rgbColor;
                if (style && style.indexOf('%') != -1) {
                    let re = new RegExp('rgb(.*?);', 'gi');
                    let matches = re.exec(style);
                    if (matches) {
                        let color = matches[1]
                            .replace('(', '')
                            .replace(')', '')
                            .replace('%', '');
                        let allParts: any[] = [];
                        [].forEach.call(color.split(','), function(part: any) {
                            allParts.push(Math.round(parseFloat(part) * 2.55));
                        });
                        rgbColor = 'rgb(' + allParts.join(',') + ')';
                    }
                } else {
                    if (getAttributesFromString(style).length > 1) {
                        let fillData = getAttributesFromString(style).find(
                            (attr: string) => attr.indexOf('fill:') !== -1,
                        );
                        rgbColor = fillData?.replace('fill:', '').replace(';', '');
                    } else {
                        rgbColor = style.replace('fill:', '').replace(';', '');
                    }
                }

                if (rgbColor && (!hasStrokeInStyle(style) || hasStrokeNoneInStyle(style))) {
                    color = formatColor(rgbColor);
                    element.fill(color);
                }

                if (hasFillNoneInStyle(style) && hasStrokeInStyle(style) && !hasStrokeNoneInStyle(style)) {
                    getAttributesFromString(style).forEach((attr: string) => {
                        let newAttrObject: { property: string; value: string };
                        const attributeSplited = attr.split(':');

                        newAttrObject = { property: attributeSplited[0], value: attributeSplited[1] };

                        if (newAttrObject.property === 'stroke') {
                            color = formatColor(newAttrObject.value);
                            if (color) {
                                element.stroke(color);
                                cleanFillInStyleAttribute(element);
                                cleanStrokeInStyleAttribute(element);
                            }
                        } else if (newAttrObject.property === 'fill') {
                            element.fill('none');
                        } else {
                            element.attr({ [newAttrObject.property]: newAttrObject.value });
                        }
                    });
                }
            } else {
                const fillAttribute = element.node.getAttribute('fill');
                const parentFillAttribute = getFillColorFromClosestParentWithFillColor(element);

                if (!fillAttribute && parentFillAttribute) {
                    color = formatColor(parentFillAttribute);
                } else {
                    color = element.fill() != -1 ? element.fill() : element.attr('data-original');
                }
                if (element.node.getAttribute('opacity')) {
                    color = color + element.node.getAttribute('opacity')?.replace('.', '');
                    if (color.length === 8) {
                        color = `${color}0`;
                    }
                }

                element.fill(color);
                element.opacity(1);
            }

            if (color.indexOf('url(#') != -1) {
                //contiene degradado
                element.attr('data-original', color);
                cleanFillInStyleAttribute(element);
            } else if (color) {
                if (formatColor(color) == '') {
                    element.node.parentNode?.removeChild(element.node);
                }

                color = formatColor(color);
                colors.push(color);

                element.attr('data-original', color);
                cleanFillInStyleAttribute(element);
            }

            if (resourceType !== 'uicon') {
                element.mouseover(function() {
                    // @ts-ignore
                    markActiveElement(this.attr('fill'), this.attr('data-original'));
                });

                element.click(function() {
                    const fillColor = getFillFromElement(element);
                    let activeColor = fillColor ? fillColor : getStrokeFromElement(element);

                    if (element.node.getAttribute('data-original')?.length === lengthExagesimalColorWithAlpha) {
                        if (element.node.getAttribute('opacity') && activeColor) {
                            activeColor =
                                activeColor +
                                element.node
                                    .getAttribute('opacity')
                                    ?.replace('0.', '')
                                    .substring(0, 2);
                        }
                    }

                    if (!activeColor) {
                        return;
                    }

                    // @ts-ignore
                    setActiveColor(activeColor, this.attr('data-original'));
                });
            }
        });
    }
    if (resourceType !== 'uicon') {
        Editor.draw.mouseout(() => unMarkActiveElement());
    }

    colors = colors.reduce((accum: string[], cur) => {
        if (accum.indexOf(cur) === -1 && cur != '') accum.push(cur);
        return accum;
    }, []);

    if (resourceType !== 'uicon') {
        let colorsWithId: string[] = [];

        if (gradients.length > 0 && colors.length == 0) {
            colorsWithId = [gradients, gradientsElementsIdArray].reduce((acc: any, actualValue) => {
                actualValue.forEach((o: any, i: number) => {
                    acc[i] = acc[i] || [];
                    acc[i].push(o);
                });
                return acc;
            }, []);

            setListColors(colorsWithId, []);
        } else if (gradients.length > 0 && colors.length > 0) {
            colorsWithId = [gradients, gradientsElementsIdArray].reduce((acc: any, actualValue) => {
                actualValue.forEach((o: any, i: number) => {
                    acc[i] = acc[i] || [];
                    acc[i].push(o);
                });
                return acc;
            }, []);
            let allColors = colors.concat(colorsWithId);

            setListColors(allColors, []);
            Object.entries(idsForChangeToXlinkHref).forEach(([key, value]) => {
                changeValues(key, value);
            });
        } else {
            setListColors(colors, []);
        }
    }
    if (resourceType === 'uicon') {
        ColorUicon.setUiconColor();
    }

};

const setListColors = function(colors: string[], ids: string[], clear: boolean = true, history: boolean = false) {
    let editorTrackerTag = 'editor';

    if (Editor.iconData?.resourceType === 'sticker') {
        editorTrackerTag = 'editor-sticker';
    }

    let iconColorsListElement = history
        ? document.getElementById('last-icon-colors')
        : document.getElementById('svg-icon-colors');

    const colorHistoryHeadingElement = document.querySelector('.text__general--heading.history');
    if (colorHistoryHeadingElement) {
        if (Array.from(document.querySelectorAll('#last-icon-colors .color')).length > 0 || history) {
            colorHistoryHeadingElement.classList.remove('hide');
        } else {
            colorHistoryHeadingElement.classList.add('hide');
        }
    }

    if (iconColorsListElement) {
        if (clear) iconColorsListElement.innerHTML = '';
        if (history && iconColorsListElement.querySelectorAll('li').length >= historyColorLimit) {
            if (iconColorsListElement.lastChild) {
                iconColorsListElement.removeChild(iconColorsListElement.lastChild);
            }
        }

        colors.forEach(function(color, index) {
            if (color.length <= 1) {
                return;
            } else {
                let html: string;
                if (!Array.isArray(color) && color?.includes('#')) {
                    html = `<li class="color%LC%">\
                <button data-original="%C%" data-actual="%C%" style="background:%C%;" onclick="ga(\'send\', \'event\', \'${editorTrackerTag}\', \'color\', \'color-change-last\')"></button>\
                </li>`;
                } else {
                    html = `<li class="color%LC%">\
                        <button data-original="${color[1]}" data-actual="%C%" style="background:%C%;" onclick="ga(\'send\', \'event\', \'${editorTrackerTag}\', \'color\', \'color-change-last\')"></button>\
                        </li>`;
                    if (index === 0) {
                        html = `<li class="color%LC%">\
                        <button class="active" data-original="${color[1]}" data-actual="%C%" style="background:%C%;" onclick="ga(\'send\', \'event\', \'${editorTrackerTag}\', \'color\', \'color-change-last\')"></button>\
                        </li>`;
                    }
                }

                if (Array.isArray(color)) {
                    color = color[0].toLowerCase();
                } else {
                    color = color.toLowerCase();
                }
                html = html
                    ?.replace('%LC%', isColorLight(color) ? ' color-light' : '')
                    .replace(new RegExp('%C%', 'g'), color);
                iconColorsListElement?.insertAdjacentHTML(history ? 'afterbegin' : 'beforeend', html);

                if (history) {
                    iconColorsListElement?.querySelector('button')?.addEventListener('click', (e: Event) => {
                        const buttonElement = e.currentTarget as HTMLElement;

                        if (buttonElement && buttonElement.dataset.actual) {
                            Editor.pickr.setColor(buttonElement.dataset.actual);
                            fireChangeColor(buttonElement.dataset.actual, true);
                            Color.setSVGColor(buttonElement.dataset.actual);
                        }
                    });
                }
            }
        });

        if (!Array.isArray(colors[0]) && !history) {
            setActiveColor(colors[0], colors[0]);
            handleEventColors();
        }
    }
};

const handleEventColors = function() {
    document.querySelectorAll('#svg-icon-colors button').forEach(buttonIconColor => {
        buttonIconColor.addEventListener('click', e => {
            let buttonElement = e.currentTarget as HTMLElement;
            if (buttonElement && buttonElement.dataset.actual && buttonElement.dataset.original) {
                setActiveColor(buttonElement.dataset.actual, buttonElement.dataset.original);
            }
        });
        buttonIconColor.addEventListener('mouseover', e => {
            let buttonElement = e.currentTarget as HTMLElement;
            if (buttonElement && buttonElement.dataset.actual && buttonElement.dataset.original) {
                markActiveElement(buttonElement.dataset.actual, buttonElement.dataset.original);
            }
        });
        buttonIconColor.addEventListener('mouseout', e => {
            let buttonElement = e.currentTarget as HTMLElement;
            if (buttonElement && buttonElement.dataset.actual) {
                unMarkActiveElement();
            }
        });
    });
};

const setActiveColor = function(color: string, originalColor: string) {
    color = color.toLowerCase();
    let buttonElement = document.querySelector(
        `#svg-icon-colors button[data-actual="${color}"][data-original="${originalColor}"]`,
    ) as HTMLElement;

    if (color.length === lengthExagesimalColorWithAlpha || originalColor.length === lengthExagesimalColorWithAlpha) {
        buttonElement = document.querySelector(
            `#svg-icon-colors button[data-original="${originalColor}"]`,
        ) as HTMLElement;
    }

    if (buttonElement) {
        document.querySelector('#svg-icon-colors button.active')?.classList.remove('active');
        buttonElement.classList.add('active');
        buttonElement.style.backgroundColor = color;
        buttonElement.dataset.actual = color;
    }
};

const setSVGColor = function(toColor: string, element?: HTMLElement) {
    let activeColorButton = element
        ? element
        : (document.querySelector('#svg-icon-colors button.active') as HTMLElement);

    if (activeColorButton) {
        let fromColor = activeColorButton.dataset.actual;
        let originalColor = activeColorButton.dataset.original;
        if (fromColor && originalColor) {
            let svgElementsStrokeToBeColored = Editor.draw.find(
                `[stroke="${fromColor.toLowerCase()}"][data-original="${originalColor.toLowerCase()}"]`,
            );
            let svgElementsToBeColored = Editor.draw.find(
                `[fill="${fromColor.toLowerCase()}"][data-original="${originalColor.toLowerCase()}"]`,
            );

            const isHexaColorWithAlpha = toColor.length > 7;
            if (svgElementsStrokeToBeColored) {
                if (isHexaColorWithAlpha) {
                    const toColorWithoutAlpha = toColor.slice(0, -2);
                    svgElementsStrokeToBeColored.forEach(element => {
                        element.stroke(toColorWithoutAlpha);

                        element.opacity(EditorHelpers.hexToAlpha(toColor.slice(-2)));
                    });
                } else {
                    svgElementsStrokeToBeColored.forEach(element => {
                        element.stroke(toColor);
                        element.opacity(1);
                    });
                }
            }

            if (svgElementsToBeColored) {
                if (isHexaColorWithAlpha) {
                    const toColorWithoutAlpaha = toColor.slice(0, -2);
                    svgElementsToBeColored.forEach(element => {
                        element.fill(toColorWithoutAlpaha);

                        element.opacity(EditorHelpers.hexToAlpha(toColor.slice(-2)));
                    });
                } else {
                    svgElementsToBeColored.forEach(element => {
                        element.fill(toColor);
                        element.opacity(1);
                    });
                }
            }
            if (isHexaColorWithAlpha) {
                toColor = toColor.slice(0, -2);
            }

            if (element) {
                activeColorButton.style.backgroundColor = toColor;
            }
            activeColorButton.dataset.old = formatColor(activeColorButton.style.backgroundColor);
            activeColorButton.dataset.actual = toColor;
        }
    }
};

const setSVGGradientColor = function(newGradientColorArray: any, svgId: any) {
    let svgGradient: any = Editor.draw.find(svgId);

    svgGradient.update((add: any) => {
        newGradientColorArray.forEach((newGradientColor: any) => {
            add.stop(
                parseFloat(newGradientColor.location),
                formatColor(newGradientColor.color),
                parseFloat(newGradientColor.color.split(',').pop()),
            );
        });
    });
};

const fireChangeColor = (color: string, fromHistory: boolean = false) => {
    let activeButton = document.querySelector('#svg-icon-colors button.active') as HTMLElement;
    let oldColor = activeButton.dataset.old
        ? formatColor(activeButton.style.backgroundColor)
        : activeButton.dataset.original;
    activeButton.style.backgroundColor = color;

    if (oldColor !== color) {
        let event: HistoryEvent = {
            type: 'color',
            data: {
                fromColor: oldColor,
                toColor: color,
                element: document.querySelector('#svg-icon-colors button.active'),
            },
        };

        if (Editor.history) {
            Editor.history.push(event);
        }

        if (!fromHistory) {
            setListColors([color], [], false, true);
        }
        activeButton.dataset.old = activeButton.dataset.actual;
    }
};

const markActiveElement = (color: string, originalColor: string) => {
    Editor.draw.attr('class', 'hovered-paths');
    let actualActiveElement = Editor.draw.find(`[class="hovered-path"]`);
    actualActiveElement.forEach(element => {
        element.attr('class', '');
    });

    if (color && originalColor) {
        let svgElements = Editor.draw.find(
            `[fill="${color.toLowerCase()}"][data-original="${originalColor.toLowerCase()}"]`,
        );
        if (originalColor.length === lengthExagesimalColorWithAlpha) {
            svgElements = Editor.draw.find(`[data-original="${originalColor}"]`);
        }

        if (originalColor.length === 1) {
            svgElements = Editor.draw.find(`[data-original="url(#${originalColor})"]`);
        }

        svgElements.forEach(element => {
            element.attr('class', 'hovered-path');
        });
    }
};

const unMarkActiveElement = () => {
    Editor.draw.attr('class', '');
    let actualActiveElement = Editor.draw.find(`[class="hovered-path"]`);
    actualActiveElement.forEach(element => {
        element.attr('class', '');
    });
};

const updateColorSvg = (button: HTMLElement) => {
    let color: any = [];
    let location: any = [];
    let buttonId = button.getAttribute('data-original');
    let updatedSvgGradient: any = Editor.draw.find(`[id="${buttonId}"]`);
    let updatedSvgGradientColors: any = updatedSvgGradient[0]?.node.children;

    if (updatedSvgGradientColors) {
        Array.from(updatedSvgGradientColors).forEach((gradientColor: any) => {
            location.push(gradientColor.getAttribute('offset'));
            color.push(gradientColor.getAttribute('stop-color'));
        });

        Editor.gradientColorsArray = [color, location].reduce((c, v) => {
            v.forEach((o: number, i: number) => {
                c[i] = c[i] || [];
                c[i].push(o);
            });
            return c;
        }, []);
    }
};

const hexToRgb = (hex: string): number[] | boolean => {
    if (hex.charAt(0) === '#') {
        hex = hex.substr(1);
    }

    if (hex.length < 2 || hex.length > 6) {
        return false;
    }

    let values = hex.split(''),
        r,
        g,
        b;

    if (hex.length === 2) {
        r = parseInt(values[0].toString() + values[1].toString(), 16);
        g = r;
        b = r;
    } else if (hex.length === 3) {
        r = parseInt(values[0].toString() + values[0].toString(), 16);
        g = parseInt(values[1].toString() + values[1].toString(), 16);
        b = parseInt(values[2].toString() + values[2].toString(), 16);
    } else if (hex.length === 6) {
        r = parseInt(values[0].toString() + values[1].toString(), 16);
        g = parseInt(values[2].toString() + values[3].toString(), 16);
        b = parseInt(values[4].toString() + values[5].toString(), 16);
    } else {
        return false;
    }

    return [r, g, b];
};

const isColorLight = (color: string): boolean => {
    if (!color) return false;
    const r = parseInt(color.substr(1, 2), 16);
    const g = parseInt(color.substr(3, 2), 16);
    const b = parseInt(color.substr(5, 2), 16);
    return r * 299 + g * 587 + b * 114 >= 225000;
};

const getAttributesFromString = (style: string): string[] =>
    style.split(';').filter(attribute => attribute !== '');

const hasStrokeInStyle = (style: string): boolean => style.indexOf('stroke') !== -1;

const hasStrokeNoneInStyle = (style: string): boolean => style.indexOf('stroke:none') !== -1;

const hasFillNoneInStyle = (style: string): boolean => style.indexOf('fill:none') !== -1;

const cleanFillInStyleAttribute = (element: Element) =>
    element.attr('style', element.attr('style')?.replace(/(fill\:[^\;]+;?)/, ''));

const cleanStrokeInStyleAttribute = (element: Element) =>
    element.attr('style', element.attr('style')?.replace(/(stroke\:[^\;]+;?)/, ''));

export const Color = {
    hasFillNoneInStyle,
    hasStrokeInStyle,
    hasStrokeNoneInStyle,
    isColorLight,
    hexToRgb,
    updateColorSvg,
    markActiveElement,
    setSVGGradientColor,
    fireChangeColor,
    setActiveColor,
    setSVGColor,
    checkGradient,
    getColors,
    setListColors,
    handleEventColors,
};

const changeValues = (id: string | null, xlinkHref: string | null) => {
    if (!xlinkHref) {
        return;
    }
    document.querySelectorAll(`path[fill="url(#${id})"]`).forEach(element => {
        element.setAttribute('fill', `url(#${xlinkHref})`);
        element.setAttribute('data-original', `url(#${xlinkHref})`);
    });
};
